import React from "react";
import { GameNotificationGameBlock } from "../../../src/server/models/game/modules/notifications/blocks";

type Props = {
    block: GameNotificationGameBlock;
}

const SIZE = '16px';

export default function NotificationGame(
    {
        block,
    }: Props,
): React.ReactNode {
    return <span>
        <b>{block.game.name}</b>&nbsp;({block.game.map.name})
    </span>
}
